import type { SiteSummary } from "@rakazo/contracts";
import { rpc } from "./rpc";

const inFlight = new Map<string, Promise<SiteSummary>>();

/** Current state of a Site. Readers that ask while a request for the same Site is in flight share it, so a thread
 * of cards sends one request per Site. `fresh` skips the shared request when the state is known to have changed.
 * Поточний стан сайту. Читачі, що питають, поки запит про той самий сайт ще летить, ділять його, тож тред карток
 * шле один запит на сайт. `fresh` оминає спільний запит, коли відомо, що стан змінився. */
export function readSite(
  spaceId: string,
  siteId: string,
  options: { fresh?: boolean } = {},
): Promise<SiteSummary> {
  const key = JSON.stringify([spaceId, siteId]);
  const shared = inFlight.get(key);
  if (shared && !options.fresh) return shared;
  const request = rpc.sites.get({ siteId }, { context: { spaceId } }).finally(() => {
    // A newer request may have replaced this one; only clear our own entry.
    if (inFlight.get(key) === request) inFlight.delete(key);
  });
  inFlight.set(key, request);
  return request;
}
